import { marketingUrl } from '@ui/lib/urls'

export const AUTH_LINK_CLASS =
  'text-blueberry-700 hover:text-blueberry-900 underline'

export function AuthLegalNotice() {
  return (
    <p className="text-muted-foreground mt-4 text-center text-xs">
      By continuing you agree to the{' '}
      <a
        href={marketingUrl('/privacy-policy')}
        className={AUTH_LINK_CLASS}
        target="_blank"
        rel="noreferrer"
      >
        Privacy Policy
      </a>{' '}
      and{' '}
      <a
        href={marketingUrl('/terms-of-service')}
        className={AUTH_LINK_CLASS}
        target="_blank"
        rel="noreferrer"
      >
        Terms of Service
      </a>{' '}
      and confirm you&apos;re 18+. We&apos;ll text you a verification code.
      Message and data rates may apply.
    </p>
  )
}
